import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useConfig } from '../context/ConfigContext';
import api from '../api';

function AdminForgotPassword() {
  const navigate = useNavigate();
  const { currentTenant, getCompanyName } = useConfig();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const companyName = currentTenant?.companyName || getCompanyName();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await api.post('/forgot-password', { email, userType: 'admin' });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="admin-login-container">
        <div className="admin-login-box">
          <div className="admin-access-badge" style={{ background: 'var(--color-success)', color: 'white' }}>
            ✓ EMAIL SENT
          </div>
          <h2 className="admin-login-title">Check Your Email</h2>
          <p className="admin-login-subtitle">
            If an admin account with that email exists, we've sent a password reset link.
            Please check your inbox and spam folder.
          </p>
          <p className="admin-login-subtitle" style={{ marginTop: '10px', fontSize: '14px' }}>
            The link will expire in 1 hour.
          </p>
          <button
            onClick={() => navigate('/admin/login')}
            className="admin-login-submit"
            style={{ marginTop: '20px' }}
          >
            Back to Admin Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-login-container">
      <div className="admin-login-box">
        <div className="admin-access-badge">
          🔐 ADMIN PASSWORD RESET
        </div>

        <h2 className="admin-login-title">
          {currentTenant ? `${companyName} Admin` : 'Admin Password Reset'}
        </h2>

        <p className="admin-login-subtitle">
          Enter your admin email address and we'll send you a link to reset your password.
        </p>

        {error && (
          <div className="admin-login-error">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="admin-form-group-last">
            <label className="admin-form-label">
              Admin Email Address
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="admin-form-input"
              placeholder="Enter your admin email"
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="admin-login-submit"
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <div className="admin-login-footer">
          <button
            onClick={() => navigate('/admin/login')}
            className="admin-back-button"
          >
            ← Back to Admin Login
          </button>
        </div>
      </div>
    </div>
  );
}

export default AdminForgotPassword;
